export const forbiddenHtmlTags = [
  '!doctype',
  'doctype',
  'html',
  'head',
  'title',
  'meta',
  'body',
  'div', // added
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'strong',
  'em',
  'span',
  'br',
  'hr',
  'blockquote',
  'q',
  'abbr',
  'cite',
  'code',
  'pre',
  'kbd',
  'samp',
  'ul',
  'ol',
  'li',
  'dl',
  'dt',
  'dd',
  'a',
  'nav',
  'link',
  'img',
  'form',
  'input',
  'textarea',
  'button',
  'select',
  'option',
  'label',
  'fieldset',
  'legend',
  'optgroup',
  'checkbox',
  'radio',
  'table',
  'tr',
  'th',
  'td',
  'thead',
  'tbody',
  'tfoot',
  'header',
  'footer',
  'main',
  'article',
  'section',
  'aside',
  'details',
  'summary',
  'figure',
  'figcaption',
  'audio',
  'video',
  'source',
  'track',
  'iframe',
  'object',
  'embed',
  'param',
  'style',
  'script',
  'noscript',
];
